import React, { useEffect, useState } from 'react';

interface TimeDisplayProps {
  show: boolean;
  showSeconds: boolean;
}

export default function TimeDisplay({ show, showSeconds }: TimeDisplayProps) {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    if (!show) return;

    setTime(new Date());
    let interval: ReturnType<typeof setInterval> | undefined;
    const now = new Date();
    const updateInterval = showSeconds ? 1000 : 60_000;
    const millisecondsUntilNextUpdate = showSeconds
      ? 1000 - now.getMilliseconds()
      : (60 - now.getSeconds()) * 1000 - now.getMilliseconds();
    const timeout = setTimeout(() => {
      setTime(new Date());
      interval = setInterval(() => setTime(new Date()), updateInterval);
    }, millisecondsUntilNextUpdate);

    return () => {
      clearTimeout(timeout);
      if (interval) clearInterval(interval);
    };
  }, [show, showSeconds]);

  const countdownStyle = (value: number) => ({
    '--value': value,
    '--digits': 2,
  } as React.CSSProperties);

  const hours = time.getHours();
  const minutes = time.getMinutes();
  const seconds = time.getSeconds();

  return (
    <div 
      className="select-none text-8xl text-white"
      style={{ 
        textShadow: '2px 2px 4px rgba(3, 3, 3, 0.05)',
      }}
    >
      <span className="countdown tabular-nums">
        <span style={countdownStyle(hours)} aria-live="polite" aria-label={String(hours)}>
          {String(hours).padStart(2, '0')}
        </span>:
        <span style={countdownStyle(minutes)} aria-live="polite" aria-label={String(minutes)}>
          {String(minutes).padStart(2, '0')}
        </span>
        {showSeconds && (
          <>:
            <span style={countdownStyle(seconds)} aria-live="polite" aria-label={String(seconds)}>
              {String(seconds).padStart(2, '0')}
            </span>
          </>
        )}
      </span>
    </div>
  );
}
